document.addEventListener('DOMContentLoaded', (event) => {
  console.log(`Théâtre - 2023\nSilex Taille Numérique\n`)
})

import '../css/index.scss'


import smoothscroll from 'smoothscroll-polyfill'
smoothscroll.polyfill()

import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'

import carousel from './carousel.js'
import iframe from './iframe.js'
Alpine.plugin(intersect)

document.addEventListener('alpine:init', () => {
  
Alpine.data('carousel', carousel)
Alpine.data('iframe', iframe)
})


window.Alpine = Alpine
window.Alpine.start()

window.addEventListener("load", (event) => {
        document.getElementsByTagName("body")[0].classList.add("loaded");




  var nav__toggle = document.getElementsByClassName("nav__toggle");
  var menu__toggle = document.getElementsByClassName("menu_main__toggle");
  var body = document.getElementsByTagName("body")[0];


  for(var i = 0; i < menu__toggle.length; i++) {
    menu__toggle[i].onclick = function(event) {
      event.preventDefault();

      if(body.classList.contains("menu_main__open")){
              body.classList.remove("menu_main__open");
      }else{
              body.classList.add("menu_main__open");
      }
      
    }
    }




  for(var i = 0; i < nav__toggle.length; i++) {


    nav__toggle[i].onclick = function(event) {
      event.preventDefault();

  
      var cible = this.getAttribute("data-id");
    
    
      if(body.classList.contains("nav_"+ cible +"__open")){
        body.className = body.className.replace("nav_"+ cible +"__open", '');
      }else{
        body.className = body.className.replace("nav_filter-superevents__open", '');
        body.className = body.className.replace("nav_filter-categories__open", '');
        body.classList.add("nav_"+ cible +"__open");
      }


    }
    }













if(document.getElementsByClassName("message__cookies").length){ 


  var closemessagescookies = document.getElementsByClassName("message_cookies__close");


  for(var i = 0; i < closemessagescookies.length; i++) {


       var closemessagescookie = closemessagescookies[i];

           closemessagescookie.onclick = function(e) {


            let message__cookies = document.getElementsByClassName("message__cookies")[0];

             let cookie__valid = e.target.getAttribute("data-valid");

            // add 1 year for the legal delai 
            var d = new Date();
        var year = d.getFullYear();
        var month = d.getMonth();
        var day = d.getDate();
        var date = new Date(year + 1, month, day);

           document.cookie = "message_cookies_box=true; path=/; expires=Tue, "+ date;
           document.cookie = "message_cookies_valid="+cookie__valid+"; path=/; expires=Tue, "+ date;


            let op = 1;  

                  let timer = setInterval(function () {
                if (op <= 0.1){
                    clearInterval(timer);
                    message__cookies.style.display = 'none';
                }
                message__cookies.style.opacity = op;
                message__cookies.style.filter = 'alpha(opacity=' + op * 100 + ")";
                op -= op * 0.1;
            }, 50);

           }
  }
}

if(document.getElementsByClassName("message_box").length){ 

  var closemessages = document.getElementsByClassName("message_box__close");


  for(var i = 0; i < closemessages.length; i++) {
            var closemessage = closemessages[i];
            closemessage.onclick = function() {

          let message_box = document.getElementsByClassName("message_box")[0];
          let dateto = message_box.getAttribute('data-to');
          let date = new Date(dateto);

          date = date.toUTCString();
                  document.cookie = "message_box=" + message_box.getAttribute('id') + "; path=/; expires=Tue, "+ date;

            let op = 1;  

                  let timer = setInterval(function () {
                if (op <= 0.1){
                    clearInterval(timer);
                    message_box.style.display = 'none';
                }
                message_box.style.opacity = op;
                message_box.style.filter = 'alpha(opacity=' + op * 100 + ")";
                op -= op * 0.1;
            }, 50);



            }
        }


}








});